<template>
  <div class="mypage-paid-plan-change-edit-pane">
    <external-confirmation-section
      :title="$tc('MypagePage.common.externalConfirmation.title.web')"
      :message="$tc('MypagePage.common.externalConfirmation.message.web')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import ExternalConfirmationSection from '@/components/common/ExternalConfirmation/ExternalConfirmationSection.vue'

/**
 * アプリ版: プラン変更(有料=>有料) ペイン
 */
export default defineComponent({
  name: 'MypagePaidPlanChangeEditPane',
  components: {
    ExternalConfirmationSection,
  },
})
</script>

<style lang="scss" scoped>
.mypage-paid-plan-change-edit-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{var(--safe-area-inset-bottom)});
  padding: 24px 0 104px;
  margin: 0 auto;
  text-align: left;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
